import { render, staticRenderFns } from "./UserArea.vue?vue&type=template&id=1012181a&scoped=true&"
import script from "./UserArea.vue?vue&type=script&lang=js&"
export * from "./UserArea.vue?vue&type=script&lang=js&"
import style0 from "./UserArea.vue?vue&type=style&index=0&id=1012181a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012181a",
  null
  
)

component.options.__file = "UserArea.vue"
export default component.exports